import React from "react";
import "./index.scss";

export interface LoadingProps {
  /** 是否显示加载状态 */
  spinning?: boolean;
  /** 加载提示文字 */
  tip?: string;
  /** 加载图标大小 */
  size?: "small" | "default" | "large";
  /** 自定义加载图标 */
  indicator?: React.ReactNode;
  /** 延迟显示加载状态的时间（毫秒） */
  delay?: number;
  /** 包裹的内容 */
  children?: React.ReactNode;
  /** 自定义类名 */
  className?: string;
  /** 自定义样式 */
  style?: React.CSSProperties;
  /** 是否显示遮罩 */
  mask?: boolean;
  /** 遮罩样式 */
  maskStyle?: React.CSSProperties;
  /** 是否显示脉冲环效果 */
  showPulseRing?: boolean;
  /** 动画类型 */
  animationType?: "spinner" | "pulse" | "both";
}

const Loading: React.FC<LoadingProps> = ({
  spinning = false,
  tip,
  size = "default",
  indicator,
  delay = 0,
  children,
  className = "",
  style,
  mask = true,
  maskStyle,
  showPulseRing = true,
  animationType = "spinner",
}) => {
  const [showSpinner, setShowSpinner] = React.useState(false);

  React.useEffect(() => {
    if (spinning) {
      if (delay > 0) {
        const timer = setTimeout(() => {
          setShowSpinner(true);
        }, delay);
        return () => clearTimeout(timer);
      } else {
        setShowSpinner(true);
      }
    } else {
      setShowSpinner(false);
    }
  }, [spinning, delay]);

  // 默认加载图标
  const defaultIndicator = (
    <div className={`loading-spinner loading-spinner-${size}`}>
      {(animationType === "spinner" || animationType === "both") && (
        <div className='loading-spinner-dot loading-spinner-dot-spin'>
          <i className='loading-spinner-dot-item'></i>
          <i className='loading-spinner-dot-item'></i>
          <i className='loading-spinner-dot-item'></i>
          <i className='loading-spinner-dot-item'></i>
        </div>
      )}
    </div>
  );

  const loadingContent = (
    <div className={`loading-container ${className}`} style={style}>
      {children}
      {showSpinner && (
        <div className='loading-wrapper'>
          {mask && <div className='loading-mask' style={maskStyle} />}
          <div className='loading-content'>
            {indicator || defaultIndicator}
            {tip && <div className='loading-text'>{tip}</div>}
          </div>
        </div>
      )}
    </div>
  );

  return loadingContent;
};

export default Loading;
